module.exports = __webpack_public_path__ + "img/IMG_5627 3.88543364.jpg";